import { render, staticRenderFns } from "./AltasDeServicioPantalla.vue?vue&type=template&id=86dab4ec&"
import script from "./AltasDeServicioPantalla.vue?vue&type=script&lang=ts&"
export * from "./AltasDeServicioPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports